import XMLParser from "react-xml-parser"
import samlED from "saml-encoder-decoder-js"
import { LANG_LIST, ROLE, SERVICE_AIDOC, SERVICE_EASY_SIPTRUNK, SERVICE_EASYUUM, SERVICE_EXPERT_CONF, SERVICE_IAM, SERVICE_IAM_SSO, SERVICE_OPERATION, SERVICE_OXESYNC, STRING, TRUE } from "./Constants";
import _ from "lodash";
import { AI_DOC_URL, EC_APP_URL, EC_URL, IAM_SSO_URL, IAM_URL, OXE_OP_URL, OXE_SYNC_URL, SIP_URL, UUM_URL } from "./Config";
import { getSessionItem, setSessionItem } from "./storageUtils";
import parse from 'html-react-parser'
import { validateMandatory } from "./ValidationUtils";
import store from "../store/store";
import { getRequest } from "./RequestActions";
import { findInObjectById } from "./SchemaParseUtils"
let navigateFn

export const validateRegex = (regexp, value = '') => {
    let regex = new RegExp(regexp);
    if (regex.test(value)) return true
    else return false
}

export function isHTMLString(str) {
    const regex = /<\/?[a-z][\s\S]*>/i;
    return regex.test(str);
}

export const parseRefAPI = (url) => {

    return url.replace(/{{(.*?)}}/g, (_, key) => getUrlForService(key))
}

// Get service api url for the provided service
export function getUrlForService(service) {
    switch (service) {
        case SERVICE_EASYUUM:
            return UUM_URL
        case SERVICE_OXESYNC:
            return OXE_SYNC_URL
        case SERVICE_IAM:
            return IAM_URL
        case SERVICE_IAM_SSO:
            return IAM_SSO_URL
        case SERVICE_EASY_SIPTRUNK:
            return SIP_URL
        case SERVICE_EXPERT_CONF:
            return EC_URL
        case SERVICE_AIDOC:
            return AI_DOC_URL
        case SERVICE_OPERATION:
            return OXE_OP_URL
        default:
            return service
    }
}

export const parseEnum = (original) => {
    let parsedEnum = []

    original?.length && original.map(item => {

        parsedEnum.push({
            label: item.name,
            value: item.id,
        })
    })

    return parsedEnum
}

export const xmlToJSON = (xml) => {
    const jsonText = new XMLParser().parseFromString(xml)

    return jsonText
}

export const decodeSamlRedirect = async (encodedData, callback) => {
    await samlED.decodeSamlRedirect(encodedData, (err, xml) => {
        if (err) {
            throw new Error(err);
        }
        else {
            callback(xml)
        }
    })
}

export const postMessageToChildIframe = (iframeRef, message) => {
    iframeRef.current?.contentWindow?.postMessage(message, EC_APP_URL);
}

export const filterAttrByType = (attribute, filterVal, filterType) => {
    // Always normalize filterVal into an array
    const filterValues = Array.isArray(filterVal) ? filterVal : [filterVal]

    // Handle string attributes (text-based filtering)
    if (typeof attribute === "string") {
        return filterValues.some(fv =>
            attribute?.toLowerCase().includes(fv.toLowerCase())
        )
    } 
    // Handle object-based attributes (multi-select enum filtering)
    else {
        return attribute?.length > 0 && attribute.some(enumItem =>
            filterValues.some(fv =>
                (enumItem.label || enumItem.id || "")
                    .toLowerCase()
                    .includes(fv.toLowerCase())
            )
        )
    }
}

export const tableListFilter = (list, searchVal) => {
    let filteredArr = []
    filteredArr = list.filter(user => {

        return Object.entries(user?.attribute).some(([key, value]) => {
            if (typeof value === "string" && value?.toLowerCase().includes(searchVal.toLowerCase())) return true
            else return false
        });
    })

    return filteredArr
}

export const getSorted = (a, b, attributeId) => {

    const extractValue = (val) => {
        if (!val) return "";

        // Direct values such as string or number
        if (typeof val === "string" || typeof val === "number") return val

        // react element with imageData
        if (val?.props?.imageData) {
            return val.props.imageData.label || val.props.imageData.id || ""
        }

        // array like [{label, id}]
        if (Array.isArray(val)) {
            const firstItem = val[0]
            if (!firstItem) return "";
            return firstItem.label || firstItem.id || ""
        }

        return String(val)
    }

    // normalize values
    const valueA = extractValue(a?.[attributeId]) || a.attribute?.[attributeId]
    const valueB = extractValue(b?.[attributeId]) || b.attribute?.[attributeId]

    // Handle null/undefined
    if (valueA == null) return 1
    if (valueB == null) return -1

    // extract alphabetic and numeric parts
    const extractParts = (val) => {
        const str = String(val)
        const letters = str.match(/[A-Za-z]+/)?.[0] || ''
        const numbers = parseInt(str.match(/\d+/)?.[0] || '0', 10)
        return [letters.toUpperCase(), numbers]
    }

    // If values contain letters and numbers
    const isAlphaNum = /[A-Za-z]/.test(valueA) || /[A-Za-z]/.test(valueB)
    if (isAlphaNum) {
        const [lettersA, numA] = extractParts(valueA)
        const [lettersB, numB] = extractParts(valueB)

        if (lettersA < lettersB) return -1
        if (lettersA > lettersB) return 1
        return numA - numB
    }

    // If both are purely numeric
    const numA = parseInt(valueA)
    const numB = parseInt(valueB)
    if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB
    }

    // string comparison
    const strA = String(valueA).toUpperCase()
    const strB = String(valueB).toUpperCase()
    return strA.localeCompare(strB)
}

/**
 * Returns a sorted version of the table data based on the selected column and order.
 *
 * Priority:
 * 1. If filtered data exists, sort that.
 * 2. Otherwise, sort the full table data.
 *
 * @param {Array} filteredData - Data after filters are applied (optional)
 * @param {Array} tableData - Complete table data
 * @param {string} columnId - Column key to sort by
 * @param {string} sortOrder - "ASC" or "DESC"
 * @returns {Array} Sorted dataset
 */
export const getSortedTableData = ({ filteredData, tableData, columnId, sortOrder }) => {

    // Choose the correct dataset: filtered list → fallback to full table
    const dataToSort = filteredData?.length ? filteredData : tableData
    if (!dataToSort?.length) return []

    // Perform sorting (client-side)
    return [...dataToSort].sort((a, b) => {
        const compareValue = getSorted(a.attribute, b.attribute, columnId)
        return sortOrder === "ASC" ? compareValue : -compareValue
    })
}

export const isListItemExist = (list, key) => {
    return list.some(item => item === key)
}

/**
 * Util function to translate dict-keys
 * @param {Object} dict [obj Arr | null] If null, dict will be taken directly from redux store 
 * @param {String} key 
 * @returns {String} returns a translated dict key
 */
export const getTranslated = (dict = [], key) => {
    const state = store.getState()
    const dictionary = dict ?? state.common.dict

    return dictionary[key] ?? key
}

export const formatDictString = (dict, key, values) => {
    const translation = getTranslated(dict, key)

    return replaceBracesWithValue(translation, values)
}

export function replaceBracesWithValue(strToReplace, values) {

    return strToReplace?.replace(/{{(\w+)}}/g, (match, key) => {
        if (values[key] === undefined) {
            console.warn(`No value provided for key: ${key}`)
            return ''
        }
        return values[key]
    })
}

/** Get HTML object from translation strings (BF 21/11/2024)
 * @param {String} dict Selected label dictionary
 * @param {String} key  key of label
 * @param {String} node html root node (default "" for <></>)
 * @example  let val = getHTMLObject(dict, "MSG_PUBLIC", "p")
 * @returns {React.ReactNode} returns HTML object
*/
export const getHTMLObject = (dict, key, node = "") => {
    const translation = getTranslated(dict, key);
    var html;

    // parse function is unable to interpret <></> correctly
    if (node !== "")
        html = parse(`<${node}>${translation}</${node}>`);
    else
        html = <>{parse(translation)}</>

    return html;
}

export const propertiesToJSON = (propertiesString) => {
    const result = propertiesString
        .split("\n") //divides lines
        .filter(Boolean) //removes empty lines
        .reduce((acc, line) => {
            _.set(acc, ...line.split("="));
            return acc;
        }, {})

    return result
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getDefaultLanguage = () => {
    const lang = getSessionItem("language") ?? LANG_LIST.find(lang => lang.key === navigator.language?.substring(0, 2))?.key
    setSessionItem("language", lang ?? 'en') // Store the default language in Sessionstorage on page load

    return lang ?? 'en'
}

export const getRole = () => {
    const roleId = getSessionItem(ROLE)

    return roleId === "0" ? "BP" : roleId === "1" ? "EC" : ""
}

export const getThemedImage = (imageName) => {
    try {
        const images = require.context('../assets/images/themed-icons');
        return images(`./${imageName}`);
    } catch (error) {
        console.warn(`Image not found: ${imageName}`);
        return ''; // Or return a fallback image path
    }
}

export const getImage = (imageName) => {
    try {
        const images = require.context('../assets/images');
        return images(`./${imageName}`);
    } catch (error) {
        console.warn(`Image not found: ${imageName}`);
        return ''; // Or return a fallback image path
    }
}

export const validateAttr = (attribute, value) => {
    let status = "", errorMsg = ""
    if (attribute?.mandatory && !validateMandatory(attribute.mandatory, value)) { // validate emptiness of mandatory field
        status = "error"
        errorMsg = "MSG_FIELD_REQUIRED"
    } else if (attribute?.regexp && !validateRegex(attribute.regexp, value)) { // validate regular expression
        status = "error"
        errorMsg = attribute.regexpHelp
    }

    return { status, errorMsg }
}

export const validateAttrGroup = async (attribute, value, urlString = null) => {
    let status = "", errorMsg = "", encodedValue = ""
    if (attribute?.mandatory && !validateMandatory(attribute.mandatory, value)) { // validate emptiness of mandatory field
        status = "error"
        errorMsg = "MSG_FIELD_REQUIRED"
    } else if (attribute?.regexp && !validateRegex(attribute.regexp, value)) { // validate regular expression
        status = "error"
        errorMsg = attribute.regexpHelp
    } else if (attribute?.refExistApi && (attribute?.value !== value) && (urlString !== '') && (urlString !== null)) {
        encodedValue = attribute?.refExistApi?.encode ? btoa(unescape(encodeURIComponent(value))) : value
        const apiResult = await getRequestHelperForRefExistApi(urlString, encodedValue);
        return apiResult
    }
    return { status, errorMsg }
}

export const getRequestHelperForRefExistApi = (urlString, encodedValue) => {
    return new Promise((resolve) => {
        getRequest(
            { url: replaceValueInUrl(urlString, encodedValue) },
            (res, status) => {
                if (status && res !== undefined && res.exists) {
                    resolve({ status: "error", errorMsg: res.message })
                } else {
                    resolve({ status: "", errorMsg: "" })
                }
            }
        )
    })
}

export const validateAttrStatus = (attribute) => {
    if (attribute?.mandatory && !validateMandatory(attribute.mandatory, attribute.value)) { // validate emptiness of mandatory field
        return false
    } else if (attribute?.regexp && !validateRegex(attribute.regexp, attribute.value)) { // validate regular expression
        return false
    }

    return true
}

const refExistDebounceTimers = {};

export const validateAttrStatusGroup = async (attribute, srcObj = null) => {

    if (attribute?.mandatory && !validateMandatory(attribute.mandatory, attribute.value))
        return false;
    else if (attribute?.regexp && !validateRegex(attribute.regexp, attribute.value))
        return false;
    else if (attribute?.refExistApi && srcObj !== null) {
        const oldValue = findInObjectById(srcObj, attribute?.id) //gets object from baseMergeData using id
        if (oldValue?.value !== attribute?.value) {
            // CLEAR previous debounce for this field
            if (refExistDebounceTimers[attribute?.id]) {
                clearTimeout(refExistDebounceTimers[attribute?.id])
            }
            return new Promise((resolve) => {
                refExistDebounceTimers[attribute.id] = setTimeout( 
                    async () => {
                        const encodedValue = attribute.refExistApi.encode ? btoa(unescape(encodeURIComponent(attribute?.value))): attribute?.value
                        const apiResult = await getRequestHelperForRefExistApi(parseRefAPI(attribute.refExistApi?.apiurl),encodedValue )
                        resolve(apiResult?.status !== "error")
                }, 600);
            });
        }
    }
    return true;
};

/** To let navigate obj accessible across all the pure JS files */
export const setNavigator = (navigate) => {
    navigateFn = navigate
}

export const navigateTo = (path) => {
    if (navigateFn) {
        navigateFn(path)
    } else {
        console.error("Navigator not set yet!")
    }
}
//To replace ant fragment of <string> with value globally
export const replaceValueInUrl = (url, value) => {
    return url.replace(/<.*?>/g, value)
}
/*----------------------------------------------*/